import {createAsyncThunk} from '@reduxjs/toolkit';
import apiInstance, {apiInstanceID} from '../../Apis/Axios';
import { FOODIE_MENU_SERVICE } from '../EndPoints';

const serviceName = "foodie-menu-service";
const endPointCafeteria = "cafeterias";
const endPoint = "shifts";

export const GetAllCafeterias = createAsyncThunk('shift/GetAllCafeterias', async () => {
    const result = await apiInstanceID.get(`${serviceName}/v1/${endPointCafeteria}/get-all`).then(function (response) {
        return response;
    })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});

export const GetAllCafeteriasByUserId = createAsyncThunk('shift/GetAllCafeteriasByUserId', async () => {
    const result = await apiInstanceID.get(`${serviceName}/v1/${endPointCafeteria}/get-all/by-user`).then(function (response) {
        return response;
    })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});

export const GetShiftById = createAsyncThunk('shift/GetShiftById', async (params, { dispatch, getState }) => {
    const response = await apiInstance.get(`${serviceName}/v1/${endPoint}/by-id/${params}`).then((response) => {
        return response;
    })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});

export const CreateShift = createAsyncThunk("shift/CreateShift",async (params, { dispatch, getState }) => {

    const response = await apiInstance.post(`${serviceName}/v1/${endPoint}/create`, params).then(function (response) {
        return response
    }).catch(function (error) {
        return error.response
    })
    const { data, status } = response

    return { data, status }
});

export const UpdateShift = createAsyncThunk("shift/UpdateShift",async (params, { dispatch, getState }) => {

    const response = await apiInstance.put(`${serviceName}/v1/${endPoint}/update`, params).then(function (response) {
        return response
    }).catch(function (error) {
        return error.response
    })
    const { data, status } = response

    return { data, status }
});

export const GetCustomAccessByShiftIdFoodie = createAsyncThunk('shift/GetCustomAccessByShiftId', async (params) => {
    const response = await apiInstance
        .post(`${FOODIE_MENU_SERVICE.getCustomAccessByShiftIdFoodie}${params.id}`, params?.body)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;

    return { data, status };
});